import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carGroupFilled"
const CarGroupFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M15.494 5.25C16.222 5.25 16.844 5.772 16.974 6.486 17.064 6.977 17.2 7.696 17.358 8.454 17.538 9.324 17.744 10.247 17.94 10.938 18.175 11.304 18.506 11.779 18.795 12.182 18.95 12.398 19.09 12.59 19.19 12.726L19.31 12.887 19.34 12.93 19.35 12.941V12.944H19.352L19.5 13.145V20.25C19.5 21.078 18.828 21.75 18 21.75H17.25C16.422 21.75 15.75 21.078 15.75 20.25H5.25C5.25 21.078 4.578 21.75 3.75 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V13.156L1.635 12.962 3.048 10.944 4.014 6.436C4.163 5.744 4.774 5.25 5.481 5.25zM3.75 14.25V16.5H7.5C7.5 15.257 6.493 14.25 5.25 14.25zM15.75 14.25C14.507 14.25 13.5 15.257 13.5 16.5H17.25V14.25zM4.678 10.5H16.277Q16.197 10.175 16.12 9.833L16.074 9.623Q16.03 9.431 15.99 9.24L15.861 8.623Q15.821 8.43 15.784 8.244L15.709 7.863C15.625 7.433 15.552 7.049 15.498 6.755 15.498 6.751 15.494 6.75 15.494 6.75H5.48z"
            clipRule="evenodd"
          />
          <path d="M17.862 2.25C18.66 2.25 19.369 2.669 19.774 3.308Q19.844 3.418 19.902 3.535 20.031 3.801 20.09 4.102C20.304 5.238 20.635 6.867 20.94 7.937 21.174 8.303 21.506 8.78 21.795 9.182 21.95 9.398 22.09 9.59 22.19 9.726L22.31 9.887 22.34 9.93 22.35 9.941V9.944H22.352L22.5 10.145V15.75C22.5 16.578 21.828 17.25 21 17.25V12.646L20.633 12.154 20.632 12.153 20.552 12.045 20.543 12.033 20.514 11.995 20.4 11.838C20.3 11.703 20.164 11.518 20.014 11.308 19.78 10.98 19.526 10.618 19.326 10.315 19.11 9.512 18.88 8.432 18.696 7.5H19.276C19.105 6.81 18.942 6.043 18.802 5.35L18.616 4.38Q18.602 4.312 18.577 4.25 18.553 4.185 18.52 4.127C18.45 4.013 18.355 3.918 18.242 3.853Q18.098 3.769 17.929 3.753 17.895 3.75 17.862 3.75H6.947L7.014 3.436C7.163 2.744 7.774 2.25 8.481 2.25z" />
        </svg>
      }
    </span>
  )
}
export default CarGroupFilledIcon
